module.exports = __webpack_public_path__ + "static/img/sanhuo.fa2a016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/sanhuo.jpg
// module id = CmDI
// module chunks = 1